var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "combination" },
    [
      _c("div", { staticClass: "title-box" }, [
        _c("span", { staticClass: "line-name" }, [_vm._v("子题")]),
        !_vm.readOnly
          ? _c("span", { staticClass: "line-dec" }, [_vm._v("管理子题")])
          : _vm._e(),
      ]),
      _vm._l(_vm.groupSubDataCopy, function (question, index) {
        return _c(
          "div",
          { key: index, staticClass: "combination-item-box" },
          [
            _c(
              "el-form",
              {
                ref: "combination",
                refInFor: true,
                staticClass: "demo-ruleForm",
                attrs: {
                  model: question,
                  rules: _vm.rule,
                  "label-width": "100px",
                },
                on: { validate: _vm.validateQuestions },
              },
              [
                _c("div", { staticClass: "combination-item-container" }, [
                  _c("div", { staticClass: "combination-item-order" }, [
                    _vm._v(" " + _vm._s(index + 1) + " "),
                  ]),
                  _c("div", { staticClass: "combination-item-content" }, [
                    _c(
                      "div",
                      {
                        ref: "name",
                        refInFor: true,
                        staticClass: "question-item",
                      },
                      [
                        _c("div", { staticClass: "title-box" }, [
                          _c("span", { staticClass: "line-name" }, [
                            _vm._v("题干"),
                          ]),
                          !_vm.readOnly
                            ? _c(
                                "span",
                                [
                                  _c("span", { staticClass: "line-dec" }, [
                                    _vm._v("请在下方输入框填写题干描述    "),
                                  ]),
                                  question["items"].value == "input"
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "insert-blank",
                                          on: {
                                            click: function ($event) {
                                              return _vm.insertBlank(
                                                question,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 插入填空 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "name", label: " " } },
                          [
                            _vm.readOnly
                              ? _c("div", {
                                  staticClass: "readonly-name",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.examName(question)),
                                  },
                                  on: { click: _vm.showImage },
                                })
                              : _vm.showUeditors && !_vm.readOnly
                              ? _c("DsfUEditor", {
                                  ref: "names",
                                  refInFor: true,
                                  attrs: {
                                    readOnly: _vm.readOnly,
                                    showLabel: false,
                                    richTxtHeight: 200,
                                    readOnlyAutoHeight: true,
                                    toolBar: _vm.toolBar,
                                  },
                                  model: {
                                    value: question["name"],
                                    callback: function ($$v) {
                                      _vm.$set(question, "name", $$v)
                                    },
                                    expression: "question['name']",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.componentIs[question["items"].value]
                      ? _c(
                          "div",
                          {
                            ref: "exam_questions_options",
                            refInFor: true,
                            staticClass: "question-item",
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "exam_questions_options",
                                  label: " ",
                                },
                              },
                              [
                                _c(_vm.componentIs[question["items"].value], {
                                  ref: "group_options",
                                  refInFor: true,
                                  tag: "component",
                                  attrs: {
                                    readOnly: _vm.readOnly,
                                    exam_questions_options:
                                      question["exam_questions_options"],
                                    dsOrder:
                                      question["exam_questions.ds_order"],
                                  },
                                  on: {
                                    "validate-single": _vm.validates,
                                    "add-judge": _vm.combinationAddJudge,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        ref: "hint",
                        refInFor: true,
                        staticClass: "question-item",
                      },
                      [
                        _c("div", { staticClass: "title-box" }, [
                          _c("span", { staticClass: "line-name" }, [
                            _vm._v("提示"),
                          ]),
                          !_vm.readOnly
                            ? _c("span", { staticClass: "line-dec" }, [
                                _vm._v("请在下方框内填写提示"),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "hint", label: " " } },
                          [
                            _vm.readOnly
                              ? _c("div", {
                                  staticClass: "readonly-name",
                                  domProps: {
                                    innerHTML: _vm._s(question["hint"]),
                                  },
                                  on: { click: _vm.showImage },
                                })
                              : _vm.showUeditors && !_vm.readOnly
                              ? _c("DsfUEditor", {
                                  ref: "hints",
                                  refInFor: true,
                                  attrs: {
                                    readOnly: _vm.readOnly,
                                    showLabel: false,
                                    richTxtHeight: 200,
                                    readOnlyAutoHeight: true,
                                    toolBar: _vm.toolBar,
                                  },
                                  model: {
                                    value: question["hint"],
                                    callback: function ($$v) {
                                      _vm.$set(question, "hint", $$v)
                                    },
                                    expression: "question['hint']",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        ref: "parse",
                        refInFor: true,
                        staticClass: "question-item",
                      },
                      [
                        _c("div", { staticClass: "title-box" }, [
                          _c("span", { staticClass: "line-name" }, [
                            _vm._v("解析"),
                          ]),
                          !_vm.readOnly
                            ? _c("span", { staticClass: "line-dec" }, [
                                _vm._v("请在下方框内填写答案解析"),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "parse", label: " " } },
                          [
                            _vm.readOnly
                              ? _c("div", {
                                  staticClass: "readonly-name",
                                  domProps: {
                                    innerHTML: _vm._s(question["parse"]),
                                  },
                                  on: { click: _vm.showImage },
                                })
                              : _vm.showUeditors && !_vm.readOnly
                              ? _c("DsfUEditor", {
                                  ref: "parses",
                                  refInFor: true,
                                  attrs: {
                                    readOnly: _vm.readOnly,
                                    showLabel: false,
                                    richTxtHeight: 200,
                                    readOnlyAutoHeight: true,
                                    toolBar: _vm.toolBar,
                                  },
                                  model: {
                                    value: question["parse"],
                                    callback: function ($$v) {
                                      _vm.$set(question, "parse", $$v)
                                    },
                                    expression: "question['parse']",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  !_vm.readOnly
                    ? _c(
                        "div",
                        { staticClass: "combination-item-delete" },
                        [
                          _c(
                            "DsfButton",
                            {
                              attrs: { disabled: _vm.readOnly },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteQustion(question)
                                },
                              },
                            },
                            [_vm._v(" 删除子题")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ],
          1
        )
      }),
      !_vm.readOnly
        ? _c(
            "div",
            { staticClass: "operation-wrapper" },
            _vm._l(_vm.items, function (item) {
              return _c(
                "DsfButton",
                {
                  key: item.value,
                  attrs: { type: "plain" },
                  on: {
                    click: function ($event) {
                      return _vm.selectItems(item)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.text) + " ")]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }